export var MuiCardHeader = {
  styleOverrides: {
    subheader: function subheader(_ref) {
      var theme = _ref.theme;
      return {
        marginTop: theme.spacing(theme.spaces.small),
        color: theme.palette.text.primary
      };
    }
  }
};
//# sourceMappingURL=MuiCardHeader.js.map